import styled from 'styled-components';
import { Picture } from 'react-responsive-picture';
import tw from 'tailwind-styled-components';
import { Title, Text } from './../Typography';

export const Container = tw.div`
text-center
md:text-left

`;
export const ImageContainer = tw.div`
text-center
md:text-left
border-corporate-darkGray
border
m-auto
max-w-screen-sm
`;

Container.displayName = 'Container';

export const AssetPic = styled(Picture)`
  width: 100%;
  height: auto;
`;
AssetPic.displayName = 'AssetPic';

export const SuperText = tw(Text)`
  mb-2.5
  text-darkgray
  opacity-70
`;
SuperText.displayName = 'SuperText';
export const TitleBig = tw(Title)`
mb-2.5
md:mb-5
`;
TitleBig.displayName = 'TitleBig';
export const Body = tw(Text)`
  mb-5
  md:mb-30
`;
Body.displayName = 'Body';

export const ButtonContainer = tw.div`
inline-block`;
